<template>
    <div class="upload-facial-photo-wrapper" v-loading.fullscreen.lock="loading" element-loading-text="数据上传中，请不要离开当前页面">
        <div class="breadcrumb">导入照片
            <el-button class="right_f" type="primary" @click="goback">返回</el-button>
        </div>

        <div class="standard-info">
            <div>
                <img src="https://swapp-image.gxapp.iydsj.com/admin-api/facial-standard-tips.png" alt="人脸照片采集标准要求说明" />
                <p>
                    将学生照片按照学号命名，并打包成压缩包，仅支持.ZIP文件上传。
                    <span style="color: red;">(ZIP包大小不超过600M)</span>
                </p>
                <p>上传错误时，存在的问题类型：</p>
                <p>1）学号不存在</p>
                <p>2）照片尺寸大于300K</p>
                <p>3）照片尺寸小于100K</p>
            </div>
        </div>

        <div class="upload-bezel">
            <el-upload ref="uploadRef" accept=".zip" :limit="1" action="#########" :http-request="httpRequest">
                <i class="el-icon-upload"></i>
                <div class="el-dragger__text">将文件拖到此处，或<em>点击上传</em></div>
            </el-upload>
        </div>
    </div>
</template>

<script>
import { OBSuploadFace } from '../../../common/huaweicloud';

export default {
    data() {
        return {
            loading: false,
            rootUnid: '',
        }
    },

    mounted() {
        this.rootUnid = this.$route.query.rootUnid;
    },

    methods: {
        // 返回
        goback() {
            history.back();
        },

        // 上传文件
        httpRequest(param) {
            let fileName = param.file.name
            const fileExt = fileName.substring(fileName.lastIndexOf('.'))
            if (fileExt !== '.zip') {
                this.$util.errorMsg('文件格式有误');
                return
            }
            this.loading = true;
            OBSuploadFace(param.file, this.rootUnid).then((res) => {
                if (res) {
                    this.submitFaceUrl(res);
                } else {
                    this.$util.errorMsg('上传文件失败');
                    this.loading = false;
                }
            })
        },

        // 提交人脸照片OBS地址
        submitFaceUrl(url) {
            this.$http({
                url: this.$util.domain + '/adminapi/v590/user/face/upload',
                method: 'POST',
                body: JSON.stringify({
                    fileUrl: url,
                    rootUnid: this.rootUnid
                })
            }).then((res) => {
                if (res.data.error == 10000) {
                    this.$util.successMsg('上传文件成功');
                    this.$refs.uploadRef.clearFiles();
                } else {
                    this.$util.errorMsg('上传文件地址失败1');
                }
            }).catch((err) => {
                this.$util.errorMsg('上传文件地址失败2');
            }).finally(() => {
                this.loading = false;
            })
        },
    }
}
</script>

<style scoped>
.upload-facial-photo-wrapper {
    overflow: hidden;
}

.standard-info {
    display: flex;
    flex-direction: column;
    align-items: center;
}

.standard-info div {
    padding: 20px;
    border: 1px solid #e0e0e0;
}

.standard-info img {
    width: 920px;
    height: auto;
}

.standard-info p {
    font-size: medium;
    line-height: 30px;
}

.upload-bezel {
    display: flex;
    flex-direction: column;
    align-items: center;
}

.upload-bezel div:nth-child(1) {
    margin-top: 20px;
    padding: 20px;
    width: 920px;
    border: 1px solid #e0e0e0;
    align-items: center;
    display: flex;
    flex-direction: column;
}
</style>


// WEBPACK FOOTER //
// UploadFacialPhoto.vue?44fe2ca2